import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Users, DollarSign, ChevronRight } from 'lucide-react';

export const PipelineStatsCards = ({ formatCurrency, pipelineStages, stats }) => (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 md:gap-4">
        <Card className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 border-blue-200">
          <CardContent className="p-2 sm:p-3 md:p-4">
            <div className="flex items-center justify-between">
              <div className="min-w-0">
                <p className="text-xs sm:text-sm text-blue-600 dark:text-blue-400 truncate">Total Patients</p>
                <p className="text-lg sm:text-xl md:text-2xl font-bold text-blue-900 dark:text-blue-100">{stats.total}</p>
              </div>
              <Users className="w-6 h-6 sm:w-8 sm:h-8 text-blue-500 flex-shrink-0" />
            </div>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 border-green-200">
          <CardContent className="p-2 sm:p-3 md:p-4">
            <div className="flex items-center justify-between">
              <div className="min-w-0">
                <p className="text-xs sm:text-sm text-green-600 dark:text-green-400 truncate">Pipeline Value</p>
                <p className="text-lg sm:text-xl md:text-2xl font-bold text-green-900 dark:text-green-100 truncate">{formatCurrency(stats.value)}</p>
              </div>
              <DollarSign className="w-6 h-6 sm:w-8 sm:h-8 text-green-500 flex-shrink-0" />
            </div>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20 border-purple-200">
          <CardContent className="p-2 sm:p-3 md:p-4">
            <div className="flex items-center justify-between">
              <div className="min-w-0">
                <p className="text-xs sm:text-sm text-purple-600 dark:text-purple-400 truncate">Active Stages</p>
                <p className="text-lg sm:text-xl md:text-2xl font-bold text-purple-900 dark:text-purple-100">{pipelineStages.length}</p>
              </div>
              <ChevronRight className="w-6 h-6 sm:w-8 sm:h-8 text-purple-500 flex-shrink-0" />
            </div>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-amber-50 to-amber-100 dark:from-amber-900/20 dark:to-amber-800/20 border-amber-200">
          <CardContent className="p-2 sm:p-3 md:p-4">
            <div className="flex items-center justify-between">
              <div className="min-w-0">
                <p className="text-xs sm:text-sm text-amber-600 dark:text-amber-400 truncate">Avg. Value</p>
                <p className="text-lg sm:text-xl md:text-2xl font-bold text-amber-900 dark:text-amber-100 truncate">
                  {formatCurrency(stats.total > 0 ? stats.value / stats.total : 0)}
                </p>
              </div>
              <DollarSign className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500 flex-shrink-0" />
            </div>
          </CardContent>
        </Card>
      </div>
);
